import Vue from 'vue'
import Vuex from 'vuex'
import login from './modules/login'
import kkm from './modules/kkm'
import helpers from './modules/helpers'
import master from './modules/master'
import shift from './modules/shift'
import assistants from './modules/assistants'
import newOrder from './modules/newOrder'
import clientIdentify from './modules/clientIdentify'
import clientCard from './modules/clientCard'
import repair from './modules/calcs/repair'
import diskrepair from './modules/calcs/diskrepair'
import change from './modules/calcs/change'
import paint from './modules/calcs/paint'
import tireStorage from './modules/calcs/tireStorage'
import motivation from './modules/motivation'
import guaranteeOrder from './modules/guaranteeOrder'
import questionnaire from './modules/questionnaire'
import imgs from './modules/imgs'
import information from './modules/information'
import idempotance from './modules/idempotance'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        login,
        tireStorage,
        paint,
        change,
        diskrepair,
        repair,
        motivation,
        master,
        shift,
        kkm,
        assistants,
        helpers,
        newOrder,
        clientIdentify,
        clientCard,
        imgs,
        guaranteeOrder,
        questionnaire,
        information,
        idempotance
    }
})
